import Button from "./common/Button"; 

function PriceBox(props) {

  let textClassName = "tw-text-lg tw-font-condensed tw-italic md:tw-uppercase md:tw-flex-1";
  textClassName += " xs:tw-leading-tight tw-p-0 tw-m-0 tw-break-words md:tw-break-normal";
  let button,
  elements = props.prices?.map((el,i)=>{
    if(i== 0){
      button = (<Button size="medium" color="orange" className="tw-w-full" href={el.link} title={el['button-text']} />);
    }
    let bgColor = (el.colorscheme == 'yellow') ? 'tw-bg-yellow' : 'tw-bg-teal-light',
        textColor = (el.colorscheme == 'yellow') ? 'tw-text-teal' : 'tw-text-white';
    return(
      <span className={bgColor+" tw-rounded-xl tw-p-4 tw-text-center  "+textColor} key={i}>
          <h3 className="tw-font-condensed tw-uppercase tw-text-2xl">{el.title} {el.price}</h3>
          <p className="tw-font-condensed tw-uppercase tw-text-lg">{el.subtitle}</p>
      </span>
    );
  });
  
  return (
    <div className="tw-grid tw-grid-flow-row tw-grid-cols-1 tw-auto-rows-auto tw-gap-y-3 tw-p-5">
       {elements}
       {button}
    </div>
  );
}

export default PriceBox;